import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import dayjs from 'dayjs';

import { toDateStruct, toDayjs } from '../models/period-picker.model';

@Injectable()
export class DateParserFormatterService extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    return toDateStruct(dayjs.tz(value, 'L'));
  }

  format(date: NgbDateStruct): string {
    return toDayjs(date).format('L');
  }
}
